import React, { useEffect, useRef, useState } from "react";
import Joinus from "../../common/Joinus";
import { initialStates, serviceswapp, gridrcs, rcsServiceDetails } from "../home/Constant";
import ServiceWappAni from "./ServiceWappAni";
import WhatWeDo from "./WhatWeDo";

const ServiceWapp = () => {
  const [showAll, setShowAll] = useState(false);
  const colors = ["#ffc250", "#e9536c", "#f4b1b8", "#1eacc0"];
  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      console.log(`Scr ${currentY.toFixed(0)}px`);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <div className="margin-topall">
      <section className="py-5 service-position">
        <div className="container">
          <div className="metabulk-bg-round">
            {colors.map((color, i) => (
              <div
                key={i}
                id={`dot_00${i}`}
                style={{
                  position: "absolute",
                  border: `${i == 0 ? "9px solid white" : "none"}`,
                  top: `${initialStates[i].top}px`,
                  left: `${initialStates[i].left}px`,
                  width: `${initialStates[i].width}px`,
                  height: `${initialStates[i].height}px`,
                  marginLeft: `${initialStates[i].marginLeft}px`,
                  opacity: initialStates[i].opacity,
                  backgroundColor: color,
                  borderRadius: "50%",
                  zIndex: 1000,
                  pointerEvents: "none",
                  willChange: "top, left, width, height, opacity, margin-left",
                }}
              />
            ))}
          </div>
          <div className="pos-z-index">
            <div className="row justify-content-center">
              <div className="col-lg-10"
                data-aos="fade-down" data-aos-delay="300"
              >
                <div className="">
                  <h5 className="yellow-sub-heading text-center py-2 ">
                    RCS Messaging (Rich Communication Services)
                  </h5>
                  {/* <h4 className="black-service-heading text-center font-align mt-3">
                                    Unlock 5x Revenue Growth
                                </h4> */}
                  <div className="smsbulk-sub-heading">
                    <div>
                      RCS Messaging (Rich Communication Services) is the next generation of SMS 
                      that delivers a WhatsApp-like experience directly inside a user’s default 
                      mobile messaging app. Unlike traditional SMS, RCS Messaging enables businesses 
                      to send rich, interactive messages with images, videos, buttons, carousels, 
                      and branded content—without requiring any third-party apps.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <WhatWeDo data={rcsServiceDetails} />
      <ServiceWappAni />
      <section className="overflow-hidden">
        <div className="container">

          {gridrcs.map((item, index) => (
            <div className="row gridflex">
              <div className={`col-lg-6 ${index % 2 === 0 ? 'order-lg-1' : 'order-lg-2'}`}
                data-aos={`fade-${index % 2 === 1 ? "left" : "right"}`} data-aos-delay="300"
              >
                <div className="d-flex gap-2">
                  <div className="circleservice">{index + 1}</div>
                  <h1 className="servicebenefit">{item.heading}</h1>
                </div>
                <div className="servicefontb ">
                  <p className=" py-2">{item.para1}</p>
                </div>
              </div>
              <div className={`col-lg-6 gridimage ${index % 2 === 0 ? 'order-lg-2' : 'order-lg-1'}`}
                data-aos={`fade-${index % 2 === 1 ? "right" : "left"}`} data-aos-delay="300"
              >
                <img className="bulkwidth" src={item.img} alt={`Visual for ${item.heading}`} />
              </div>
            </div>
          ))}
        </div>
      </section>
      {/* <WhatDo/> */}
      <section className="py-5">
        <div className="container">
          <div>
            <h1 className="faqfont">FAQs - (RCS SMS)</h1>
          </div>
          <div className="py-5 overflow-hidden">
            <div class="accordion" id="accordionExample"
              data-aos="fade-left" data-aos-delay="300"
            >
              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingOne">
                  <button
                    class="accordion-button d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    <span class="me-3 toggle-icon"></span>
                    What is RCS Messaging?
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  class="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body sms-span">
                    RCS Messaging is a communication protocol that enables rich,
                    interactive, and engaging messaging experiences between
                    individuals and businesses.
                  </div>
                </div>
              </div>

              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingTwo">
                  <button
                    class="accordion-button collapsed d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    <span class="me-3 toggle-icon"></span>
                    Can I send multimedia messages using RCS Messaging?
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    Yes, you can send multimedia messages, including images,
                    videos, and audio files, using RCS Messaging.
                  </div>
                </div>
              </div>
              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingThree">
                  <button
                    class="accordion-button collapsed d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    <span class="me-3 toggle-icon"></span>
                    Can I use RCS Messaging for business-to-business (B2B)
                    messaging?
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    Yes, RCS Messaging can be used for B2B messaging, such as
                    supply chain management and logistics.
                  </div>
                </div>
              </div>

              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingFour">
                  <button
                    class="accordion-button collapsed d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                  >
                    <span class="me-3 toggle-icon"></span>
                    How RCS Messaging Works
                  </button>
                </h2>
                <div
                  id="collapseFour"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingFour"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <ul>
                      <li>
                        Business registers for{" "}
                        <span className="boldspan">
                          RCS Business Messaging (RBM).
                        </span>
                      </li>
                      <li>
                        Sends{" "}
                        <span className="boldspan">rich media messages </span>{" "}
                        using{" "}
                        <span className="boldspan">
                          Google Messages (Android phones).
                        </span>
                      </li>
                      <li>
                        Customers interact with the message just like a chat
                        app.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingFive">
                  <button
                    class="accordion-button collapsed d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFive"
                    aria-expanded="false"
                    aria-controls="collapseFive"
                  >
                    <span class="me-3 toggle-icon"></span>
                    Why Should Businesses Use RCS Messaging?
                  </button>
                </h2>
                <div
                  id="collapseFive"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingFive"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <ul>
                      <li>Boosts customer engagement</li>
                      <li>More powerful than SMS with multimedia support</li>
                      <li>Secure & verified sender profiles</li>
                      <li>No app installation needed for customers</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingSix">
                  <button
                    class="accordion-button collapsed d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseSix"
                    aria-expanded="false"
                    aria-controls="collapseSix"
                  >
                    <span class="me-3 toggle-icon"></span>
                    How is RCS different from SMS?
                  </button>
                </h2>
                <div
                  id="collapseSix"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingSix"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <div class="table-responsive">
                      <table class="table table-bordered">
                        <thead class="table-light">
                          <tr>
                            <th>Feature</th>
                            <th>SMS</th>
                            <th>RCS</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Text Only</td>
                            <td>
                              <i className="fa-solid fa-check" style={{ color: '#29c529' }}></i>
                            </td>
                            <td>
                              <i className="fa-solid fa-xmark" style={{ color: 'red' }}></i>
                            </td>

                          </tr>
                          <tr>
                            <td>Images &amp; Videos</td>
                            <td>
                              <i class="fa-solid fa-xmark" style={{ color: 'red' }}></i>
                            </td>
                            <td>
                              <i class="fa-solid fa-check" style={{ color: '#29c529' }}></i>
                            </td>
                          </tr>
                          <tr>
                            <td>Read Receipts</td>
                            <td>
                              <i class="fa-solid fa-xmark" style={{ color: 'red' }}></i>
                            </td>
                            <td>
                              <i class="fa-solid fa-check" style={{ color: '#29c529' }}></i>
                            </td>
                          </tr>
                          <tr>
                            <td>Typing Indicators</td>
                            <td>
                              <i class="fa-solid fa-xmark" style={{ color: 'red' }}></i>
                            </td>
                            <td>
                              <i class="fa-solid fa-check" style={{ color: '#29c529' }}></i>
                            </td>
                          </tr>
                          <tr>
                            <td>Quick-Reply Buttons</td>
                            <td>
                              <i class="fa-solid fa-xmark" style={{ color: 'red' }}></i>
                            </td>
                            <td>
                              <i class="fa-solid fa-check" style={{ color: '#29c529' }}></i>
                            </td>
                          </tr>
                          <tr>
                            <td>Brand Verification</td>
                            <td>
                              <i class="fa-solid fa-xmark" style={{ color: 'red' }}></i>
                            </td>
                            <td>
                              <i class="fa-solid fa-check" style={{ color: '#29c529' }}></i>
                            </td>
                          </tr>
                          <tr>
                            <td>End-to-End Encryption</td>
                            <td>
                              <i class="fa-solid fa-xmark" style={{ color: 'red' }}></i>
                            </td>
                            <td>
                              <i class="fa-solid fa-check" style={{ color: '#29c529' }}></i>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingSeven">
                  <button
                    class="accordion-button collapsed d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseSeven"
                    aria-expanded="false"
                    aria-controls="collapseSeven"
                  >
                    <span class="me-3 toggle-icon"></span>
                    Do customers need an app to use RCS?
                  </button>
                </h2>
                <div
                  id="collapseSeven"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingSeven"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    No. RCS messages appear in the{" "}
                    <span className="boldspan">Google Messages</span> or{" "}
                    <span className="boldspan">Samsung Messages </span>app
                    (default messaging app on most Android devices).
                  </div>
                </div>
              </div>
              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingEight">
                  <button
                    class="accordion-button collapsed d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseEight"
                    aria-expanded="false"
                    aria-controls="collapseEight"
                  >
                    <span class="me-3 toggle-icon"></span>
                    How do businesses use RCS Messaging?
                  </button>
                </h2>
                <div
                  id="collapseEight"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingEight"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <ul>
                      <li>Order tracking & updates</li>
                      <li>Promotions & offers</li>
                      <li>Product recommendations & carousels</li>
                      <li>Appointment reminders & scheduling</li>
                      <li>Payments & transaction confirmations</li>
                      <li>Two-way customer support</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingNine">
                  <button
                    class="accordion-button collapsed d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseNine"
                    aria-expanded="false"
                    aria-controls="collapseNine"
                  >
                    <span class="me-3 toggle-icon"></span>
                    Does RCS work on iPhones?
                  </button>
                </h2>
                <div
                  id="collapseNine"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingNine"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    Currently,{" "}
                    <span className="boldspan">
                      RCS is only supported on Android devices.
                    </span>{" "}
                    Apple has not yet integrated RCS into iMessage.
                  </div>
                </div>
              </div>
              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingTen">
                  <button
                    class="accordion-button collapsed d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTen"
                    aria-expanded="false"
                    aria-controls="collapseTen"
                  >
                    <span class="me-3 toggle-icon"></span>
                    Is RCS messaging secure?
                  </button>
                </h2>
                <div
                  id="collapseTen"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingTen"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    Yes! RCS messages come from{" "}
                    <span className="boldspan">verified business profiles</span>{" "}
                    and include{" "}
                    <span className="boldspan">end-to-end encryption,</span>{" "}
                    reducing fraud and spam.
                  </div>
                </div>
              </div>
              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingEleven">
                  <button
                    class="accordion-button collapsed d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseEleven"
                    aria-expanded="false"
                    aria-controls="collapseEleven"
                  >
                    <span class="me-3 toggle-icon"></span>
                    What happens if a customer’s phone doesn’t support RCS?
                  </button>
                </h2>
                <div
                  id="collapseEleven"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingEleven"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    If RCS is not supported, the message
                    <span className="boldspan">
                      automatically falls back to SMS/MMS
                    </span>
                    , ensuring delivery.
                  </div>
                </div>
              </div>
              {showAll && (
                <>
                  <div class="accordion-item border-top">
                    <h2 class="accordion-header" id="headingTwelve">
                      <button
                        class="accordion-button collapsed d-flex align-items-center"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwelve"
                        aria-expanded="false"
                        aria-controls="collapseTwelve"
                      >
                        <span class="me-3 toggle-icon"></span>
                        Is RCS Messaging better than WhatsApp Business?
                      </button>
                    </h2>
                    <div
                      id="collapseTwelve"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingTwelve"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        RCS is{" "}
                        <span className="boldspan">
                          built into Android devices
                        </span>
                        , so no extra app installation is required. However,{" "}
                        <span className="boldspan">WhatsApp Business </span>
                        offers additional chatbot and API features.
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item border-top">
                    <h2 class="accordion-header" id="headingThirteen">
                      <button
                        class="accordion-button collapsed d-flex align-items-center"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThirteen"
                        aria-expanded="false"
                        aria-controls="collapseThirteen"
                      >
                        <span class="me-3 toggle-icon"></span>
                        How much does RCS messaging cost?
                      </button>
                    </h2>
                    <div
                      id="collapseThirteen"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingThirteen"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        <ul>
                          <li>Number of messages sent</li>
                          <li>Region/country of delivery</li>
                          <li>Message format (text, images, videos, etc.)</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item border-top">
                    <h2 class="accordion-header" id="headingFourteen">
                      <button
                        class="accordion-button collapsed d-flex align-items-center"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFourteen"
                        aria-expanded="false"
                        aria-controls="collapseFourteen"
                      >
                        <span class="me-2 toggle-icon"></span>
                        Why should businesses use RCS?
                      </button>
                    </h2>
                    <div
                      id="collapseFourteen"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingFourteen"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        <ul>
                          <li>Higher engagement than SMS</li>
                          <li>Rich media support for better communication</li>
                          <li>Verified sender IDs for trust & security</li>
                          <li>
                            Better conversion rates with interactive features
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </>
              )}
              <div className="text-center py-3 ">
                <button
                  className="btn-sm viewbtn"
                  onClick={() => setShowAll(!showAll)}
                >
                  {showAll ? "View Less" : "View More"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Joinus />
    </div>
  );
};

export default ServiceWapp;
